import { GENERATION_TOOL } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';

import { LocalStore } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, [
  'generationToolOptionsCache',
  'generationTool',
  'customMultiPromptId',
]);

export const useMultiPromptCache = () => {
  const { generationToolOptionsCache, generationTool, customMultiPromptId } = useLocalState();
  const cacheKey =
    generationTool +
    (generationTool === GENERATION_TOOL.customMultiPrompt ? customMultiPromptId : '');
  if (
    !generationToolOptionsCache[cacheKey]?.multiPromptFields &&
    !generationToolOptionsCache[cacheKey]?.toolPrompts
  ) {
    return false;
  }

  if (generationToolOptionsCache[cacheKey]?.toolPrompts) {
    return true;
  }

  return Object.values(generationToolOptionsCache[cacheKey]?.multiPromptFields).some((field) => {
    return !!field.serialized;
  });
};
